import { useQuery } from '@tanstack/react-query';

import { ConnectionValidationResponse } from '@/api/auth/types';
import { RequestOptions, axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getConnectionStatus = (options?: RequestOptions): Promise<ConnectionValidationResponse> => {
    return axios.get('/connection/validate-data-connection', {
        headers: { 'Cache-Control': 'no-cache' },
        ...options,
    });
};

type QueryFnType = typeof getConnectionStatus;

type UseConnectionStatusOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useConnectionStatus = ({ config }: UseConnectionStatusOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['validate-data-connection'],
        queryFn: ({ signal }) => getConnectionStatus({ signal }),
    });
};
